var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9166 39.2104L37.5897 33.4592V15.5699C37.6215 14.1401 36.4776 12.9644 35.0477 12.9326H34.9524C34.8571 12.9326 34.7935 12.9326 34.6982 12.9326C33.3637 13.0915 32.3469 14.2354 32.3787 15.5699V35.0161C32.3787 35.9694 32.8871 36.8273 33.7132 37.2722L45.3746 43.7542C46.6138 44.4533 48.2025 44.0084 48.9016 42.7374C49.6324 41.4982 49.1876 39.9095 47.9166 39.2104Z",
    fill: "#4CCD8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0159 0C15.6968 0 0 15.6968 0 35.0159C0 54.3032 15.6968 70.0318 35.0159 70.0318C54.3032 70.0318 70.0318 54.335 70.0318 35.0159C70 15.6968 54.3032 0 35.0159 0ZM35.0159 64.8207C18.5247 64.8207 5.21108 51.507 5.21108 35.0159C5.21108 18.5247 18.5247 5.21108 35.0159 5.21108C51.507 5.21108 64.8207 18.5247 64.8207 35.0159C64.8207 51.507 51.507 64.8207 35.0159 64.8207Z",
    fill: "#0E3368"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock2.af129dcf.svg";
export { ForwardRef as ReactComponent };